export class AnalyticsApi {
  async getArtistProfileViews(artistId: string, days: number = 7) {
    // TODO: Implement actual Google Analytics API call using artistId and days
    console.log(`Fetching profile views for artist ${artistId} over last ${days} days`)
    return { rows: [{ metricValues: [{ value: '1' }] }] }
  }
}